import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('page-loader', Component);

    const active = ref(false);

    let title = ref('Something very important is happening!');

    const show = (text) => {
      if (text) {
        title.value = text;
      } else {
        title.value = 'Something very important is happening!';
      }

      active.value = true;
    }

    const hide = () => {
      active.value = false;
    }

    const toggle = () => {
      active.value = !active.value;
    }

    const pageLoader = { active, show, hide, toggle, title };

    app.config.globalProperties.$pageLoader = pageLoader;
    app.provide('$pageLoader', pageLoader);
  }
}